class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    console.log("PredictiveSearch constructor called");
    this.input = this.querySelector('input[type="search"]');
    this.formattedInput = this.querySelector("[data-search-formatted-input]");
    this.predictiveSearchResults = this.querySelector("[data-predictive-search]");
    this.cachedResults = {};
    this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search");
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = "";
    this.mobileSearchCloseEl = this.querySelector(".close_search.mobile");
    this.resetButton = document.querySelector(".reset__button");
    this.body = document.querySelector("body");

    this.setupEventListeners();
  }

  setupEventListeners() {
    console.log("Setting up event listeners");
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
    console.log(this.input.form);
    this.input.addEventListener("input", this.onChange.bind(this));
    this.input.addEventListener("focus", this.onFocus.bind(this));

    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
    this.addEventListener("keydown", this.onKeydown.bind(this));

    this.querySelector(".close_search.mobile").addEventListener("click", () => {
      console.info("alfie close search");
      this.onCloseButtonClick();
    });
  }

  getQuery() {
    console.log("Getting query");
    let query = this.input.value.trim();
    if (query.length) {
      query += " -variants.sku:-bb";
    }
    return query;
  }

  onChange() {
    console.log("onChange called");
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      console.log("Removing previous results");
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    }

    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      console.log("Empty search term, closing");
      // this.close(true);
      return;
    }
    this.formattedInput.value = newSearchTerm;

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    const searchTerm = this.getQuery();
    event.preventDefault();

    if (!searchTerm) {
      console.log("Preventing submission of empty query");
      event.preventDefault();
    } else if (this.querySelector('[aria-selected="true"] a')) {
      console.log("Preventing default form submission for selected option");
      event.preventDefault();
      this.selectOption();
    } else {
      console.log("Allowing form submission");
      // Allow the form to submit normally
      event.target.submit();
    }
  }

  onFocus() {
    console.log("onFocus called");
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      this.onChange();
    } else if (this.getAttribute("results") === "true") {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut(event) {
    console.log("onFocusOut called");

    // Check if the screen width is greater than 768px (desktop screens)
    if (window.innerWidth > 768) {
      const resetButton = this.querySelector(".reset__button");

      // Check if the event target is not the reset button
      if (event.target !== resetButton) {
        // Use setTimeout to delay the close action slightly
        setTimeout(() => {
          // Double-check that the active element is not within the search component
          if (!this.contains(document.activeElement)) {
            console.log("Closing predictive search on desktop");
            this.close(true);
          }
        }, 0);
      } else {
        console.log("Reset button clicked, not closing predictive search");
        this.input.value = "";
        this.input.focus();
        // Optionally, you can add any specific behavior for reset button click here
      }
    } else {
      const resetButton = this.querySelector(".reset__button");
      if (event.target !== resetButton) return;
      this.input.value = "";
      this.input.focus();
    }
  }

  onKeyup(event) {
    switch (event.code) {
      case "ArrowUp":
        event.preventDefault();
        this.switchOption("up");
        break;
      case "ArrowDown":
        event.preventDefault();
        this.switchOption("down");
        break;
      case "Enter":
        event.preventDefault();
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    if (event.code === "ArrowUp" || event.code === "ArrowDown") {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector("[data-predictive-search-search-for-text]");
    let currentButtonText = searchForTextElement?.innerText;
    currentButtonText = currentButtonText?.replace(" -variants.sku:-bb", "").trim();
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, "g"))?.length > 1) return;
      const newButtonText = currentButtonText.replace(
        previousTerm.replace(" -variants.sku:-bb", ""),
        newTerm.replace(" -variants.sku:-bb", ""),
      );
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute("open")) return;

    const moveUp = direction === "up";
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allVisibleElements = Array.from(this.querySelectorAll("li, button.predictive-search__item")).filter(
      (element) => element.offsetParent !== null,
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = allVisibleElements.findIndex((el) => el === selectedElement);

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute("aria-selected", true);
    if (selectedElement) selectedElement.setAttribute("aria-selected", false);

    this.input.setAttribute("aria-activedescendant", activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
    if (selectedOption) {
      selectedOption.click();
    } else {
      // If no option is selected, submit the form
      console.log("No option selected, submitting form");
      const searchTerm = this.getQuery();
      console.log("Search term:", searchTerm);
      if (searchTerm) {
        this.submitSearch(searchTerm);
      } else {
        console.log("Empty search term, not submitting");
      }
    }
    this.close();
  }

  submitSearch(searchTerm) {
    const form = this.input.form;
    const inputElement = form.querySelector('input[name="q"]');
    if (inputElement) {
      inputElement.value = searchTerm.replace(" -variants.sku:-bb", "");
    } else {
      console.log("Search input not found in form");
    }
    form.submit();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

    // Add a 1-second pause
    // const pause = new Promise(resolve => setTimeout(resolve, 1000));

    if (this.cachedResults[queryKey]) {
      console.log("Using cached results");
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(
      `/search/suggest?q=${encodeURIComponent(
        searchTerm,
      )}&resources[type]=product,query,page&resources[options][fields]=title,product_type,variants.title,vendor,body&section_id=predictive-search`,
      {
        signal: this.abortController.signal,
      },
    )
      .then((response) => {
        if (!response.ok) {
          console.error("Fetch response not ok");
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        console.log("Received search results");
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) return;
        console.error("Error fetching search results:", error);
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText = this.loadingText || this.getAttribute("data-loading-text");
    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = statusText;
    setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute("results", true);
    this.removeAttribute("loading");
    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute("loading");
    this.setLiveRegionText(this.querySelector("[data-predictive-search-live-region-count-value]").textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector(".shopify-section.header").getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    // this.predictiveSearchResults.style.maxHeight = `490px`;
    this.setAttribute("open", true);
    this.input.setAttribute("aria-expanded", true);
    this.isOpen = true;
    console.log(this.input.value);
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm) {
      console.log("Clearing search term");
      this.input.value = "";
      this.removeAttribute("results");
      document.querySelector(".icon--search").classList.remove("hidden");
      document.getElementById("search-field").classList.remove("no_search_icon");
      document.querySelector("#search-field").value = "";
      if (document.getElementById("predictive-search-results") !== null) {
        document.getElementById("predictive-search-results").setAttribute("style", "display:none !important");
      }
    }
    const selected = this.querySelector('[aria-selected="true"]');
    if (selected) selected.setAttribute("aria-selected", false);

    this.input.setAttribute("aria-activedescendant", "");
    this.input.blur();
    this.removeAttribute("loading");
    this.setAttribute("open", false);
    this.querySelector(".reset__button").classList.add("hidden");
    this.input.setAttribute("aria-expanded", false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute("style");
    let searchContainer = document.querySelector(".show__search");
    searchContainer?.classList.remove("show__search");
    this.body.classList.remove("showing__search");
    this.body.classList.remove("showingScroll");
    this.isOpen = false;
  }

  onCloseButtonClick(event) {
    console.log("Close button clicked");
    // event.preventDefault();
    // event.stopPropagation();
    // Add any additional close logic here
    // For example, you might want to clear the input and close the search
    // this.input.value = '';
    this.close(true);
  }
}

customElements.define("predictive-search", PredictiveSearch);
